var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72 0 0 6.72 0 15C0 23.28 6.72 30 15 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 15 0ZM16.5 25.5H13.5V22.5H16.5V25.5ZM19.605 13.875L18.255 15.255C17.175 16.35 16.5 17.25 16.5 19.5H13.5V18.75C13.5 17.1 14.175 15.6 15.255 14.505L17.115 12.615C17.67 12.075 18 11.325 18 10.5C18 8.85 16.65 7.5 15 7.5C13.35 7.5 12 8.85 12 10.5H9C9 7.185 11.685 4.5 15 4.5C18.315 4.5 21 7.185 21 10.5C21 11.82 20.46 13.02 19.605 13.875Z",
    fill: "#0088FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.9db4fc520a99061d3712d6f69431ae27.svg";
export { ForwardRef as ReactComponent };